var __bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; },
  __hasProp = {}.hasOwnProperty,
  __extends = function(child, parent) { for (var key in parent) { if (__hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
  __indexOf = [].indexOf || function(item) { for (var i = 0, l = this.length; i < l; i++) { if (i in this && this[i] === item) return i; } return -1; };

define(['jquery', 'underscore', 'underscore.string', 'backbone', 'core', 'model/document', 'app-common/component/api-call', 'app-common/component/comments-single', 'app-common/component/notes', 'app-common/component/categorizer-notes', 'common/component/je-history', 'app-common/component/loader', 'app-common/component/binary-toggle', 'common/component/date-formatter', 'common/component/money-formatter', 'app-common/component/combobox', 'component/document-viewer', 'template/report/je-history.htm', 'template/report/transaction-view.htm', 'common/location'], function($, _, _s, Backbone, core, DocumentModel, apiCall, SingleConversationView, NotesView, CategorizationNotesView, jeHistory, loader, BinaryToggleView, dateFormatter, moneyFormatter, Combobox, DocumentViewer, jeHistoryTemplate, transactionTemplate, locationConfig) {
  var TransactionView;
  return TransactionView = (function(_super) {

    __extends(TransactionView, _super);

    function TransactionView() {
      this.syncNotes = __bind(this.syncNotes, this);
      this.renderCategorization = __bind(this.renderCategorization, this);
      TransactionView.__super__.constructor.apply(this, arguments);
    }

    TransactionView.prototype.className = 'transaction-view';

    TransactionView.prototype.events = {
      'click .transaction-view__edit-toggle:not(.disabled)': 'editToggleHandler',
      'click .transaction-view__document-entry-button:not(.disabled)': 'documentEntryButtonHandler',
      'change .transaction-view__tax-toggle': 'toggleTax',
      'change [name=transaction-view__ledger-combobox]': 'ledgerComboboxHandler',
      'click .transaction-view__ledgers': 'ledgersToggleExpandHandler',
      'click .transaction-view__receipt-preview': 'receiptPreview',
      'click .transaction-view__icon-button': 'clickChild'
    };

    TransactionView.prototype.documentModel = {};

    TransactionView.prototype.editMode = false;

    TransactionView.prototype.expandLedgers = false;

    TransactionView.prototype.$notes = function() {
      return this.$('.transaction-view__notes');
    };

    TransactionView.prototype.$categorization = function() {
      return this.$('.transaction-view__categorization');
    };

    TransactionView.prototype.initialize = function(settings) {
      this.settings = settings || {};
      TransactionView.__super__.initialize.apply(this, arguments);
      return this.initHotkeys();
    };

    TransactionView.prototype.getId = function() {
      return this.documentModel.id;
    };

    TransactionView.prototype.setData = function(data) {
      var _this = this;
      this.clear();
      this.documentModel = new DocumentModel(data);
      this.documentModel.on('computedValuesDone', function() {
        var dataToUpdate;
        dataToUpdate = {
          id: _this.documentModel.get('id'),
          vendor: _this.documentModel.get('vendor'),
          dataEntries: _this.documentModel.get('dataEntries'),
          taxAmount: _this.documentModel.get('taxAmount'),
          salesTaxApplicationStatus: _this.documentModel.get('salesTaxApplicationStatus'),
          internalNotes: _this.documentModel.get('internalNotes'),
          categorization: _this.documentModel.get('categorization')
        };
        _this.trigger('change', {
          data: dataToUpdate
        });
        return _this.render();
      });
      if (data.file !== void 0) {
        return this.documentModel.init(false);
      } else {
        return this.documentModel.init();
      }
    };

    TransactionView.prototype.initHotkeys = function() {
      var _this = this;
      $(document).off('keydown.transaction-view');
      return $(document).on('keydown.transaction-view', function(e) {
        if (_this.isVisible() && (e.which || e.keyCode) === 69 && (core.isMac() ? e.metaKey : e.ctrlKey)) {
          e.preventDefault();
          _this.editToggleHandler();
          return false;
        } else if (_this.isVisible() && _this.editMode && (e.which || e.keyCode) === 83 && (core.isMac() ? e.metaKey : e.ctrlKey)) {
          e.preventDefault();
          _this.editToggleHandler();
          return false;
        } else if (_this.isVisible() && e.ctrlKey && (e.which || e.keyCode) === 84) {
          e.preventDefault();
          _this.toggleTax();
          return false;
        } else {
          return true;
        }
      });
    };

    TransactionView.prototype.clear = function() {
      var _ref, _ref1;
      this.$el.find('.transaction-view__comments').html('');
      this.$el.find('.transaction-view__history').html('');
      if ((_ref = this.notesView) != null) {
        _ref.destroy();
      }
      this.notesView = null;
      if ((_ref1 = this.categorizationNotesView) != null) {
        _ref1.destroy();
      }
      return this.categorizationNotesView = null;
    };

    TransactionView.prototype.render = function() {
      var $commentContainer, $history, $ledgers, $vendor, addOnName, collection, document, ledgerList, ledgerListAccountIds, ledgerSelectClassName, oldComments, oldHistory, previewImageHref, previewImagePath, promise, taxToggle, _ref, _ref1, _ref2, _ref3,
        _this = this;
      document = _.extend({}, this.documentModel.toJSON());
      previewImagePath = (_ref = document.file) != null ? (_ref1 = _ref.toJSON().pages) != null ? (_ref2 = _ref1[0]) != null ? _ref2.reportView : void 0 : void 0 : void 0;
      previewImageHref = previewImagePath ? locationConfig.apiRoot + previewImagePath : void 0;
      addOnName = this.getAddonName(document);
      oldComments = this.$el.find('.transaction-view__comments').html();
      oldHistory = this.$el.find('.transaction-view__history').html();
      this.$el.html(_.template(transactionTemplate, {
        moneyFormatter: moneyFormatter,
        id: document.id,
        amount: document.amount,
        vendor: _s.escapeHTML(document.vendor),
        date: dateFormatter.format(document.documentDate, {
          shortMonth: true
        }),
        previewImage: previewImageHref,
        editMode: this.editMode,
        expandLedgers: this.expandLedgers || this.editMode,
        ledgers: this.documentModel.getLedgers(),
        salesTaxAmount: document.taxAmount,
        history: oldHistory,
        comments: oldComments,
        isBookkeeper: core.isCurrentClientBookkeeper(),
        addOnName: addOnName
      }));
      this.renderCategorization(document.id);
      if (((_ref3 = this.settings) != null ? _ref3.type : void 0) !== 'unmatched-receipts') {
        this.renderNotes();
      }
      $history = this.$el.find('.transaction-view__history');
      jeHistory.init(document.id, jeHistoryTemplate, true, function(html) {
        $history.html(html);
        if (!(oldHistory != null ? oldHistory.length : void 0) > 0) {
          return $history.velocity('fadeIn', 200);
        }
      });
      $commentContainer = this.$el.find('.transaction-view__comments');
      promise = apiCall('document', document.id + '/comment_id');
      promise.success(function(res) {
        var view;
        view = new SingleConversationView(res, 'Leave a comment for your client...');
        view.on('change', function() {
          return _this.trigger('change', {
            data: {
              id: _this.getId()
            }
          });
        });
        view.setElement($commentContainer[0]);
        view.render();
        if (!(oldComments != null ? oldComments.length : void 0) > 0) {
          return $commentContainer.velocity('fadeIn', 200);
        }
      });
      promise.fail(function(err) {
        console.error(err);
        return $commentContainer.text('Sorry! We couldn\'t load the comments for this transaction.');
      });
      if (this.editMode) {
        this.$el.addClass('transaction-view--edit');
        if (this.documentModel.isTaxApplicable()) {
          taxToggle = new BinaryToggleView(null, null, null, [
            {
              name: 'TAX',
              value: true
            }, {
              name: 'NO TAX',
              value: false
            }
          ], this.documentModel.isTaxApplied()).render().el;
          this.$el.find('.transaction-view__tax-toggle').append(taxToggle).show();
        }
        $vendor = this.$el.find('.transaction-view__vendor');
        $vendor.attr('contenteditable', 'true');
        $vendor[0].focus();
        collection = core.getCollection('ledgerAccounts');
        ledgerList = collection.filter(function(account) {
          return account.isEditable();
        }).map(function(ledger) {
          return {
            name: ledger.get('name'),
            value: ledger.get('id')
          };
        });
        ledgerListAccountIds = ledgerList.map(function(ledger) {
          return ledger.value;
        });
        ledgerSelectClassName = 'transaction-view__ledger-combobox';
        $ledgers = this.$el.find('.transaction-view__ledger');
        $ledgers.each(function(i) {
          var $combobox, $ledger, accountId, id;
          $ledger = $($ledgers[i]);
          accountId = ($ledger.data('account-id')).toString();
          id = ($ledger.data('id')).toString();
          if (__indexOf.call(ledgerListAccountIds, accountId) >= 0) {
            $combobox = $((new Combobox(ledgerSelectClassName, '', ledgerSelectClassName, ledgerList, accountId)).show());
            $combobox.data('account-id', accountId);
            $combobox.data('id', id);
            return $ledger.html($combobox);
          }
        });
        $("." + ledgerSelectClassName).flexselect();
      } else {
        this.$el.removeClass('transaction-view--edit');
      }
      if (this.isCurrentReportFinished()) {
        this.hideEditingControls();
      } else {
        this.showEditingControls();
      }
      return this;
    };

    TransactionView.prototype.renderCategorization = function(transactionId) {
      var html, _ref;
      this.categorizationNotesView = new CategorizationNotesView(this.documentModel);
      return html = (_ref = this.$categorization()) != null ? _ref.html(this.categorizationNotesView.setData(transactionId, this.documentModel)) : void 0;
    };

    TransactionView.prototype.syncNotes = function(notes) {
      var promise,
        _this = this;
      this.documentModel.set('internalNotes', notes);
      loader.init({
        inline: true
      });
      promise = this.documentModel.save();
      promise.always(function() {
        return loader.hide();
      });
      return promise.success(function() {
        _this.trigger('change', {
          data: {
            id: _this.getId()
          }
        });
        return core.trackEvent("Notes saved", {
          updated_field: "notes",
          batch_mode: false,
          count: 1
        });
      });
    };

    TransactionView.prototype.renderNotes = function(documentId) {
      var _ref;
      if (documentId == null) {
        documentId = this.documentModel.get('id');
      }
      if (this.notesView) {
        return (_ref = this.notesView) != null ? _ref.render(this.$notes()) : void 0;
      }
      return this.notesView = new NotesView({
        transactionId: documentId,
        $container: this.$notes(),
        internalNotes: this.documentModel.get('internalNotes'),
        syncNotes: this.syncNotes
      });
    };

    TransactionView.prototype.getAddonName = function(document) {
      var addOn, addOns;
      if (!document || !document.addOnId) {
        return null;
      }
      addOns = core.getCollection('addOn').toJSON();
      addOn = addOns.find(function(addOn) {
        return addOn.id === document.addOnId;
      });
      if (addOn) {
        return addOn.name;
      }
      return null;
    };

    TransactionView.prototype.hide = function() {
      this.$el.parent().velocity('stop').velocity('transition.slideRightOut', {
        duration: 100,
        queue: false
      });
      return this.editMode = false;
    };

    TransactionView.prototype.show = function() {
      return this.$el.parent().velocity('stop').velocity('transition.slideRightIn', {
        duration: 500,
        queue: false
      });
    };

    TransactionView.prototype.isVisible = function() {
      return this.$el.is(':visible');
    };

    TransactionView.prototype.wasCategorized = function(oldLedgerId, newLedgerId) {
      var ledgers;
      ledgers = core.getCollection('ledgerAccounts');
      return ledgers.get(oldLedgerId).isAwaitingCategory() && !ledgers.get(newLedgerId).isAwaitingCategory();
    };

    TransactionView.prototype.ledgerComboboxHandler = function(e) {
      var $parent, $target, dataEntries, dataEntryId, newLedgerAccountId, oldLedgerAccountId, oldVendorName, promise, targetDataEntry,
        _this = this;
      oldVendorName = this.getVendorName();
      $target = $(e.currentTarget);
      $parent = $target.parent();
      dataEntryId = $parent.data('id');
      newLedgerAccountId = $target.val();
      if (this.documentModel.get('documentType' === 'RECEIPT')) {
        toSave.receiptId = this.documentModel.get('fileId');
      }
      dataEntries = this.documentModel.get('dataEntries');
      targetDataEntry = _.findWhere(dataEntries, {
        id: dataEntryId.toString()
      });
      oldLedgerAccountId = targetDataEntry.ledgerAccountId;
      targetDataEntry.ledgerAccountId = newLedgerAccountId;
      this.documentModel.set('dataEntries', dataEntries);
      loader.init({
        inline: true
      });
      promise = this.documentModel.save();
      promise.success(function() {
        if (_this.wasCategorized(oldLedgerAccountId, newLedgerAccountId)) {
          _this.categorizationNotesView.removeBKNotificationEvents();
        }
        return core.trackEvent("Transaction Updated", {
          updated_field: "ledger",
          batch_mode: false,
          count: 1
        });
      });
      return promise.always(function() {
        loader.hide();
        _this.render();
        return _this.setVendorName(oldVendorName);
      });
    };

    TransactionView.prototype.editToggleHandler = function() {
      if (this.isCurrentReportFinished()) {
        return;
      }
      this.editMode = !this.editMode;
      this.saveVendor();
      return this.render();
    };

    TransactionView.prototype.getVendorName = function() {
      var $vendorNameElement;
      $vendorNameElement = this.$el.find('.transaction-view__vendor');
      if ($vendorNameElement) {
        return $vendorNameElement.text().trim();
      }
    };

    TransactionView.prototype.setVendorName = function(name) {
      var $vendorNameElement;
      $vendorNameElement = this.$el.find('.transaction-view__vendor');
      return $vendorNameElement.html(name);
    };

    TransactionView.prototype.saveVendor = function() {
      var currentVendorName, newVendorName;
      currentVendorName = this.documentModel.get('vendor').trim();
      newVendorName = this.getVendorName();
      if (currentVendorName === newVendorName) {
        return;
      }
      this.documentModel.set('vendor', newVendorName);
      return this.documentModel.save();
    };

    TransactionView.prototype.documentEntryButtonHandler = function() {
      return core.getRouter().loadPage('document-entry', [this.documentModel.id, 'single']);
    };

    TransactionView.prototype.toggleTax = function() {
      var promise, url,
        _this = this;
      if (!core.isCurrentClientBookkeeper()) {
        return;
      }
      url = !this.documentModel.isTaxApplied() ? this.documentModel.applySalesTax() : this.documentModel.unapplySalesTax();
      promise = $.sendAndReceiveJSON({
        data: {
          transactionalDocumentId: this.documentModel.id
        },
        url: url
      });
      loader.init({
        inline: true
      });
      return promise.always(function() {
        _this.documentModel.fetch();
        return loader.hide();
      });
    };

    TransactionView.prototype.ledgersToggleExpandHandler = function() {
      if (!this.editMode) {
        this.expandLedgers = !this.expandLedgers;
        return this.render();
      }
    };

    TransactionView.prototype.receiptPreview = function(e) {
      return new DocumentViewer({
        document: this.getId()
      });
    };

    TransactionView.prototype.remove = function() {
      $(document).off('keydown.transaction-view');
      return this.hide();
    };

    TransactionView.prototype.isCurrentReportFinished = function() {
      return $('.page-wrapper').hasClass('status-finished');
    };

    TransactionView.prototype.hideEditingControls = function() {
      this.$el.find('.transaction-view__icon-button').addClass('disabled');
      return this.$el.find('.transaction-view__icon-button').children().addClass('disabled');
    };

    TransactionView.prototype.showEditingControls = function() {
      this.$el.find('.transaction-view__icon-button').removeClass('disabled');
      return this.$el.find('.transaction-view__icon-button').children().removeClass('disabled');
    };

    TransactionView.prototype.clickChild = function(e) {
      if (e.target !== e.currentTarget) {
        return;
      }
      return $(e.currentTarget).find('.control').click();
    };

    return TransactionView;

  })(Backbone.View);
});
